import { services } from '../services';
var action = "booking";

export const bookingService = {
    getList,
    getOne,
    insert,
    update,
    remove,
    extend,
    delay,
    getReceipt,
    getBookingByProperty,
    getListByCustomer,
    removeByProperty,
    isSold
};

function getList(param = '') {
    return services.restApi(`${action}${param}`, 'GET');
}

function getOne(id) {
    return services.restApi(`${action}/${id}`, 'GET');
}
function getReceipt(id) {
    return services.restApi(`${action}/getreceipt/${id}`, 'GET');
}
function insert(object) {
    return services.restApi(`${action}`, 'POST', object);
}

function update(id, object) {
    return services.restApi(`${action}/${id}`, 'PUT', object);
}

function remove(id) {
    return services.restApi(`${action}/${id}`, 'DELETE');
}

function extend(object) {
    return services.restApi(`${action}/extend`, 'POST', object);
}

function getBookingByProperty(id) {
    return services.restApi(`cancelation/booking/${id}`, 'GET');
}

function delay(object) {
    return services.restApi(`${action}/delay`, 'POST', object);
}

function getListByCustomer(id) {
    return services.restApi(`booking-customer/${id}`, 'GET');
}

function removeByProperty(id) {
    return services.restApi(`${action}/property/${id}`, 'DELETE');
}

function isSold(id) {
    return services.restApi(`${action}/sold/${id}`, 'GET');
}